import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebServiceEndpoints } from '@common/web-service-endpoints';

export class PingResponse {
  public Pong: string;
}

export class VersionResponse {
  public Version: string;
}

@Injectable()
export class ContactcCenterMwHeraldService {
  constructor(private readonly http: HttpClient) {}

  async ping(componentName: string): Promise<PingResponse> {
    return this.http.get<PingResponse>(WebServiceEndpoints.Herald.ping(componentName)).toPromise();
  }

  async version(componentName: string): Promise<VersionResponse> {
    return this.http.get<VersionResponse>(WebServiceEndpoints.Herald.version(componentName)).toPromise();
  }
}
